import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { GraduationCap, Menu, X, LogIn, UserRound, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const nav = [
  { to: "/okullar", label: "Okullar" },
  { to: "/bursluluk-sinavlari", label: "Bursluluk Sınavları" },
  { to: "/deneme-sinavlari", label: "Deneme Sınavları" },
  { to: "/cikmis-sorular", label: "Çıkmış Sorular" },
  { to: "/blog", label: "Blog" },
  { to: "/nasil-calisir", label: "Nasıl" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const dashHref = user
    ? user.role === "admin" ? "/admin"
    : user.role === "school" ? "/okul-paneli"
    : "/panel"
    : "/giris";

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 glass" data-testid="site-navbar">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <img src="/logo.jpg" alt="Sano Student Logo" className="h-10 object-contain" />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace(/\//g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                    isActive ? "text-primary bg-primary/5" : "text-muted-foreground hover:text-foreground hover:bg-muted"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-2">
            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="outline" size="sm" data-testid="nav-user-menu">
                    <UserRound className="h-4 w-4" /> {user.name.split(" ")[0]}
                    <ChevronDown className="h-3 w-3 opacity-60" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-52">
                  <DropdownMenuItem onClick={() => navigate(dashHref)} data-testid="nav-goto-panel">
                    Panelim
                  </DropdownMenuItem>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout">
                    Çıkış Yap
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <>
                <Button asChild variant="ghost" size="sm" data-testid="nav-login-btn">
                  <Link to="/giris"><LogIn className="h-4 w-4" /> Giriş</Link>
                </Button>
                <Button asChild size="sm" className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="nav-register-btn">
                  <Link to="/kayit">Ücretsiz Kayıt</Link>
                </Button>
              </>
            )}
          </div>

          <button
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-md hover:bg-muted"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Menü"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <div className="mx-auto max-w-7xl px-4 py-3 flex flex-col gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium rounded-md ${isActive ? "text-primary bg-primary/5" : "text-foreground hover:bg-muted"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <div className="mt-2 flex gap-2">
              {user ? (
                <>
                  <Button asChild className="flex-1" onClick={() => setOpen(false)}>
                    <Link to={dashHref}>Panelim</Link>
                  </Button>
                  <Button variant="outline" className="flex-1" onClick={() => { logout(); setOpen(false); }}>Çıkış</Button>
                </>
              ) : (
                <>
                  <Button asChild variant="outline" className="flex-1"><Link to="/giris" onClick={() => setOpen(false)}>Giriş</Link></Button>
                  <Button asChild className="flex-1"><Link to="/kayit" onClick={() => setOpen(false)}>Kayıt</Link></Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
